import { ReactNode } from 'react';
import {
  Public, Flight, Language, Category, Payments, Badge, Contacts, SupportAgent,
  Settings, AccountBalance, Stars, Event, Subscriptions, DirectionsCar,
  Restaurant, ShoppingCart, Build, Storage,
} from '@mui/icons-material';

const ICON_MAP: Record<string, ReactNode> = {
  Public: <Public fontSize="small" />,
  Flight: <Flight fontSize="small" />,
  Language: <Language fontSize="small" />,
  Category: <Category fontSize="small" />,
  Payments: <Payments fontSize="small" />,
  Badge: <Badge fontSize="small" />,
  Contacts: <Contacts fontSize="small" />,
  SupportAgent: <SupportAgent fontSize="small" />,
  Settings: <Settings fontSize="small" />,
  AccountBalance: <AccountBalance fontSize="small" />,
  Stars: <Stars fontSize="small" />,
  Event: <Event fontSize="small" />,
  Subscriptions: <Subscriptions fontSize="small" />,
  CardMembership: <Subscriptions fontSize="small" />,
  DirectionsCar: <DirectionsCar fontSize="small" />,
  Restaurant: <Restaurant fontSize="small" />,
  ShoppingCart: <ShoppingCart fontSize="small" />,
  Build: <Build fontSize="small" />,
  Storage: <Storage fontSize="small" />,
};

/** Resolve MUI icon from backend catalog metadata (icon field on each group). */
export function resolveMasterGroupIcon(iconName?: string): ReactNode {
  if (iconName && ICON_MAP[iconName]) return ICON_MAP[iconName];
  return ICON_MAP.Category;
}
